<template>
  <div>
    <v-container pt-7 px-6 ma-0 fluid>
      <v-row no-gutters>
        <v-col>
          <v-card style="border-radius: 20px;" class="white">
            <v-card-title class="header-border pa-0 ma-0">
              <v-row class="ml-0" no-gutters align="start" justify="start" style="width: 0px;">
                <v-col cols="auto">
                  <tabs-cadu
                    :tabs="tabs"
                    :currentTab="currentTab"
                    :borderColor="greenColor"
                    :textColor="greyColor"
                    :textColorActive="greenColor"
                  />
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="4" lg="3" class="pb-0 pt-0" :style="showLine">
                  <LeftAdministracao :index="tabIndex" @changeAll="changeAll" />
                </v-col>

                <v-col cols="12" sm="12" md="8" lg="9" :class="$vuetify.breakpoint.xs ? 'pt-0 pb-10' : 'pb-4'">
                  <RightAdministracao :tabIndex="tabIndex" :tabName="tabNameSelected" />

                  <v-row justify="end" align="end" class="mr-1" v-if="tabNameSelected !== 'E-mail Áreas'">
                    <v-col cols="auto">
                      <button-cadu
                        @click="$router.push('/home')"
                        text="VOLTAR"
                        :backColor="$vuetify.theme.themes.light.primary2"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <error-modal v-model="error" :errObj="errObj" />

    <overlay-loading v-model="loadingOverlay" />

    <NovaUnimedModal v-model="showNovaUnimed" />
  </div>
</template>

<script>
import LeftAdministracao from './LeftAdministracao'
import RightAdministracao from './RightAdministracao'
import jwtDecode from 'jwt-decode'
import NovaUnimedModal from './NovaUnimedModal'

export default {
  components: {
    RightAdministracao,
    LeftAdministracao,
    NovaUnimedModal
  },
  data() {
    return {
      tabs: [{ title: 'ADMINISTRAÇÃO DO SISTEMA', value: 'adm', disabled: false }],
      currentTab: 'adm',
      tabIndex: 0,
      tabNameSelected: 'E-mail Áreas',
      greenColor: this.$vuetify.theme.themes.light.primary1,
      greyColor: '#9E9E9E',
      opcaoEditar: JSON.parse(localStorage.getItem('optionEdit')),
      showError: false,
      errObj: { status: 'Status', error: 'Error' },
      role: '',
      tokenBearer: localStorage.getItem('tokenBearer'),
      showModalCancelar: false,
      showButtonCancelar: true,
      codigoUnimedVisualizada: this.unimedId,
      usuario: {},
      codigoMinhaUnimed: null,
      showModalAnexo: false,
      abaAnexo: '',
      showSuccessAnexo: false,
      messageAnexo: 'Documento anexado com sucesso!',
      type: 'add',
      anotherModal: false,
      linhaVertical: { 'border-right': '1px solid #DEE2E6', height: '100%' },
      error: false,
      loadingOverlay: false,
      showNovaUnimed: false
    }
  },
  beforeMount() {
    this.role = jwtDecode(this.tokenBearer).role

    if (this.role !== 'admin_brasil') {
      this.tabNameSelected = 'Manuais'
      this.$emit('name', this.tabNameSelected)
    }
  },
  methods: {
    changeAll(obj) {
      const name = obj.tabName
      const index = obj.index

      if (name === 'Nova Unimed') {
        this.showNovaUnimed = true
      } else {
        this.tabNameSelected = name
        this.tabIndex = index
        this.$emit('name', name)
      }
    }
  },
  computed: {
    showLine() {
      return !(this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? this.linhaVertical : ''
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #E8E8E8

.header-border
  border-bottom: 2px solid $corBorda
</style>
